<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-row class="text-left">
      <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="nickName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">登录账号</span>
        <el-input v-model.trim="userName" placeholder="请输入" style="width: 150px;"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">创建时间</span>
        <el-date-picker
            v-model="createDate"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">角色</span>
        <el-select v-model="roleId" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId"/>
        </el-select>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">最后登录日期</span>
        <el-date-picker
            v-model="lastLoginDate"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">状态</span>
        <el-select v-model="openFlag" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.id"/>
        </el-select>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getRolePermPageFn()" >
          搜索
        </el-button>
        <el-button type="primary" @click="editBtn(1)" >
          新增账号
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" :header-row-class-name="'my-table-header'">
      <el-table-column align="center" prop="nickName" label="用户名"></el-table-column>
      <el-table-column align="center" prop="userName" label="登录账号"></el-table-column>
      <el-table-column align="center" prop="roleName" label="角色"></el-table-column>
      <el-table-column align="center" prop="lastLoginTime" label="最后登录日期"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建日期"></el-table-column>
      <el-table-column align="center" prop="openFlag" label="状态"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{row}">
          <a class="glob-a" @click="editBtn(3, row)">{{row.openFlagValue == 'NONPROHIBITED' ? '禁用' : '启用'}}</a>
          <a class="glob-a" @click="editBtn(4, row)">角色绑定</a>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 新增用户 -->
    <el-dialog title="新增用户" :visible.sync="friendData.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="用户名">
          <el-input v-model.trim="friendData.nickName"  placeholder="请输入用户名"/>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model.trim="friendData.userName"  placeholder="请输入登录账号"/>
        </el-form-item>
        <el-form-item label="初始密码">
          <el-input v-model.trim="friendData.initPassword"  placeholder="请输入初始密码"/>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="friendData.roleId"  placeholder="不限" clearable>
            <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId"/>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="friendData.modal = false">取 消</el-button>
        <el-button type="primary" @click="editBtn(2)">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 角色绑定 -->
    <el-dialog title="角色绑定" :visible.sync="roleBinding.modal" width="500px">
      <el-form label-width="120px">
        <el-form-item label="角色">
          <el-select v-model="roleBinding.roleId"  placeholder="不限" clearable>
            <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId" />
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="roleBinding.modal = false"> 取 消 </el-button>
        <el-button type="primary" @click="editBtn(5)"> 确 定 </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import {
    getRolePermPage,
    getRoleList,
    backNewUsers,
    setUserStatus,
    addOrEditUserRole
  } from '@/api/index'

  export default {
    name: 'RoleUser',
    data () {
      return {
        roleList:[],
        nickName:'',
        userName:'',
        roleName:[],
        openFlag:[],
        status: '1',
        createDate:[],
        tableData: [],
        roleId:[],
        lastLoginDate:[],
        tableLoading: false,
        pages: {
          page: 1,
          total: 0
        },
        statusList: [
          {name: '禁用', id: 'PROHIBIT'},
          {name: '正常', id: 'NONPROHIBITED'},
        ],
        // 新增账号
        friendData: {
          modal: false,
          ratio: '',
          content: ''
        },
        //角色绑定
        roleBinding:{
          roleId:'',
          userId:'',
          userRoleId:'',
          modal: false
        }
      }
    },
    created () {
      this.getRolePermPageFn()
      this.getRoleListFn()
    },
    methods: {
      getRolePermPageFn () {
        this.tableLoading = true
        getRolePermPage({
          pageNum: this.pages.page,
          content: this.word,
          nickName:this.nickName,
          userName:this.userName,
          startTime: this.createDate && this.createDate.length ? this.createDate[0] : '',
          endTime: this.createDate && this.createDate.length > 1 ? this.createDate[1] : '',
          roleId:this.roleId,
          lastLogonStartDate:this.lastLoginDate && this.lastLoginDate.length ? this.lastLoginDate[0] : '',
          lastLogonEndDate: this.lastLoginDate && this.lastLoginDate.length > 1 ? this.lastLoginDate[1] : '',
          openFlag: this.openFlag
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      pageChange (val) {
        this.pages.page = val
        this.getRolePermPageFn()
      },
      getRoleListFn () {
      getRoleList().then(res => {
          this.roleList = res.data
        })
      },
      //1查看 2新增 3 禁用 4查看角色 5换绑角色
      editBtn (t,row) {
        switch (t) {
          case 1:
            this.friendData.modal = true
            break
          case 2:
            backNewUsers({
              nickName: this.friendData.nickName,
              userName: this.friendData.userName,
              initPassword: this.friendData.initPassword,
              roleId: this.friendData.roleId,
            }).then(res => {
              this.$message.success(res.data)
              this.friendData.modal = false
            })
            break
          case 3:
            var tips = row.openFlagValue == "NONPROHIBITED" ? "禁用" : "启用";
            this.$confirm(`确认${tips}吗`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              setUserStatus({
                userId: row.userId,
                openFlag: row.openFlagValue == 'NONPROHIBITED' ? 'PROHIBIT' : 'NONPROHIBITED'
              }).then(res => {
                this.$message.success(res.data)
                this.getAgentPageFn()
              })
            }).catch(() => {
            })
            break
            case 4:
             console.log(row)
              this.roleBinding = {
                roleId: row.roleId,
                userId:row.userId,
                userRoleId: row.userRoleId,
                modal: true
              }

            break
          case 5:
            addOrEditUserRole({
              userId: this.roleBinding.userId,
              roleId: this.roleBinding.roleId,
              userRoleId:this.roleBinding.userRoleId,
            }).then(res => {
              this.$message.success(res.data)
              this.roleBinding.modal = false
              this.getRolePermPageFn()
            })
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>
